/**
 * Labstep
 *
 * @module models/rich-text
 * @desc Typescript export class for RichText
 */

import { Entity } from 'labstep-web/models/entity.model';

export enum Type {
  html = 'html',
  r = 'r',
  clike = 'clike',
  mathematica = 'mathematica',
  python = 'python',
}

export class RichText extends Entity {
  static readonly entityName = 'rich_text' as const;

  get entityName(): string {
    return RichText.entityName;
  }

  constructor(data: Partial<RichText> = {}) {
    super();
    Object.assign(this, data);
  }

  id!: number;

  type!: Type;

  description!: string;
}
